var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"notificationAlert",attrs:{"transition":"slide-x-transition","type":_vm.type,"icon":_vm.iconProcessed,"dismissible":"","dense":""},model:{value:(_vm.isDisplayed),callback:function ($$v) {_vm.isDisplayed=$$v},expression:"isDisplayed"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }